import { computed } from 'vue'

import { getCurrentInstance } from '@/util'

export default function useLoading() {
  const instance = getCurrentInstance()

  function setLoading(value: boolean) {
    instance.proxy.$loading.value = value
  }

  const loading = computed(() => instance.proxy.$loading.value)

  return {
    loading,
    setLoading,
  }
}
